import { OTA_RateQualifier } from "./ota_ratequalifier.model";
import { OTA_RateDistance } from "./ota_ratedistance.model";
import { OTA_Charge } from "./ota_charge.model";

export class OTA_RentalRate {
    public confidential: boolean;
    public rateQualifier = new OTA_RateQualifier();
    public rateDistance = new OTA_RateDistance();
    public vehCharges = new Array<OTA_Charge>();
}